import { selectIsRecorderSession } from 'features/recorder/recorderSlice';
import { selectIsRestreamerSession } from 'features/restreamer/restreamerSlice';
import { RootState } from 'store/store';
import { SystemRole } from 'features/room/types';

export const selectIsSystemSession = (state: RootState) =>
  selectIsRecorderSession(state) || selectIsRestreamerSession(state);

export const selectCurrentSystemRole = (state: RootState): SystemRole | null => {
  if (selectIsRecorderSession(state)) {
    return 'recorder';
  }

  if (selectIsRestreamerSession(state)) {
    return 'restreamer';
  }
  return null;
};
